var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGooglePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 23,
    rx: 1.78571,
    fill: "white",
    stroke: "#E5E5EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3281 14.4709V11.7642V11.7637H18.8428C19.4673 11.7641 19.9921 11.5744 20.4173 11.1946C20.847 10.8342 21.0872 10.3161 21.075 9.77598C21.0835 9.23887 20.8437 8.72454 20.4173 8.36531C19.9958 7.9835 19.429 7.77517 18.8428 7.78664H16.4113V14.4709H17.3281ZM17.3281 10.9429V8.6096V8.60907H18.8656C19.2082 8.60004 19.5386 8.7292 19.7727 8.96373C20.0082 9.17822 20.1411 9.47283 20.1411 9.78053C20.1411 10.0882 20.0082 10.3828 19.7727 10.5973C19.5357 10.8269 19.2064 10.9524 18.8656 10.9429H17.3281Z",
    fill: "#5F6368"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7922 10.2571C24.4001 9.91789 23.8652 9.74829 23.1876 9.74829C22.3171 9.74829 21.6597 10.047 21.2156 10.6443L22.023 11.1206C22.3214 10.7159 22.7267 10.5136 23.2388 10.5136C23.5653 10.51 23.8813 10.6218 24.1237 10.8267C24.3654 11.0139 24.5045 11.2929 24.5024 11.5867V11.783C24.1501 11.5963 23.7018 11.503 23.1574 11.503C22.5196 11.5037 22.0098 11.6438 21.6279 11.9232C21.246 12.2027 21.055 12.579 21.055 13.0523C21.0467 13.4832 21.2463 13.8947 21.5982 14.1723C21.9604 14.471 22.4105 14.6203 22.9484 14.6203C23.5786 14.6203 24.0835 14.359 24.4631 13.8363H24.503V14.471H25.3799V11.6523C25.3803 11.0614 25.1844 10.5963 24.7922 10.2571ZM22.3055 13.6309C22.1135 13.5013 22.0002 13.2927 22.0015 13.0709C22.0015 12.8219 22.1262 12.6144 22.3773 12.4437C22.6259 12.2755 22.9365 12.1915 23.3089 12.1915C23.8202 12.1915 24.2189 12.2981 24.5047 12.5115C24.5047 12.872 24.3529 13.1861 24.0492 13.4539C23.7756 13.7101 23.4048 13.8543 23.0179 13.8549C22.76 13.8594 22.5083 13.7803 22.3055 13.6309Z",
    fill: "#5F6368"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4138 9.89758L27.3525 16.4869H26.4061L27.5421 14.1813L25.5292 9.89758H26.5257L27.9806 13.1829H28.0005L29.4156 9.89758H30.4138Z",
    fill: "#5F6368"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6233 11.1808C13.6236 10.9191 13.6 10.6579 13.5527 10.4H9.68616V11.8789H11.9007C11.8091 12.3562 11.5133 12.7778 11.0819 13.0458V14.0058H12.4035C13.1774 13.3376 13.6233 12.3493 13.6233 11.1808Z",
    fill: "#4285F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.68616 14.9333C10.7926 14.9333 11.7242 14.593 12.4035 14.0064L11.0819 13.0464C10.714 13.28 10.2402 13.4133 9.68616 13.4133C8.61675 13.4133 7.70906 12.7381 7.38448 11.8282H6.02295V12.8176C6.71889 14.1146 8.13627 14.9332 9.68616 14.9333Z",
    fill: "#34A853"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38453 11.8283C7.21294 11.3515 7.21294 10.8352 7.38453 10.3584V9.36908H6.023C5.4409 10.4539 5.4409 11.7327 6.023 12.8176L7.38453 11.8283Z",
    fill: "#FBBC04"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.68616 8.7733C10.2709 8.76436 10.8358 8.97127 11.259 9.3493V9.3493L12.4292 8.2533C11.6871 7.60054 10.7041 7.24217 9.68616 7.2533C8.13627 7.25337 6.71889 8.07199 6.02295 9.36904L7.38448 10.3584C7.70906 9.4485 8.61675 8.7733 9.68616 8.7733Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGooglePay);
export default __webpack_public_path__ + "static/media/logo-google-pay.ac93a760cbb315adb34f545c6e24e847.svg";
export { ForwardRef as ReactComponent };